import "./main.scss";

import { renderApp } from "./renderer-app";

renderApp();
